import React from 'react'

const EmailNotification = props => {
    
    return<>
          <p>Turn this off if you do not wish to receve any emails from influencers</p>
     </>
}



export default EmailNotification;